import type { AllRouteEndpoints } from "../routeTypes";

// Empty on purpose: useCreateIpPoolMutation appends the new pool to the cached configuration data
// instead of refetching every pool from SES.
export const postCompaniesCompanyIdEmailSelfServeIpPoolCacheKeys: AllRouteEndpoints[] = [];
